.lottie {
  margin: 0 auto;
  width: 100%;
}